<template>
  <div class="inventory-wrapper">
    <div>
      <v-toolbar-title
        class="d-flex my-2 my-lg-0 overflow-visible pl-2 justify-space-between titleBar "
        style="width: 100%; margin-bottom: 20px !important;"
      >
        <span style="font-weight: 700 !important"> {{ $t('sitePage.devices') }}</span>
      </v-toolbar-title>
      <div class="devicesWrapper">
        <FlowMeterHubTab />
        <ControllerTab />
        <ProductSensorTab />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ProductSensorTab from '@/views/sites/devices/productSensorsHubs/ProductSensorsTab.vue';
import ControllerTab from './controllersHubs/ControllerTab.vue';
import FlowMeterHubTab from './flowMetersHubs/FlowMetersHubTab.vue';

export default {
    components: {
        ProductSensorTab,
        ControllerTab,
        FlowMeterHubTab,
    },
    data() {
        return {
            updatedData: null,
            clientStatus: null,
        };
    },
    computed: {
        ...mapGetters([
            'site',
            'hasPermission',
            'hasRole',
        ]),
    },

    methods: {
        ...mapActions({
            reloadSite: 'getSiteInfo',
        }),
    },
};
</script>

<style lang="scss">
.devicesWrapper {
    display: grid;
    row-gap: .5rem;
    .v-data-table__wrapper {
        height: auto !important;
    }
}
</style>
